<template>
  <div class="indexs">
    <Seacher @search="searchs"></Seacher>

    <div class="content_top" id="list">
      <div class="head">Address</div>
      <div class="content_center centers">
        <div class="block_height">
          <div class="block_con">
            <div class="block_hasha">
              {{ address }}
            </div>
            <img
              src="../../assets/m/home/erwm.png"
              v-clipboard:copy="address"
              v-clipboard:success="copyClicked"
              v-clipboard:error="onError"
            />
            <!-- <img
              @click="dialogVisible = true"
              src="../../assets/m/home/ewm.png"
            /> -->
          </div>
        </div>
        <!-- <div
          class="block_height"
          v-if="tfscAddress !== '' && tfscAddress !== address"
        >
          <div class="block_con">
            <div class="block_hasha">
              {{ tfscAddress }}
            </div>
            <img
              src="../../assets/m/home/erwm.png"
              v-clipboard:copy="tfscAddress"
              v-clipboard:success="copyClicked"
              v-clipboard:error="onError"
            />
          
          </div>
        </div> -->
        <div class="block_height">
          <div class="block_tit">Total Balance :</div>
          <div class="block_con">{{ available1 }}</div>
        </div>
        <div class="block_height bkheight">
          <div class="block_tit">Available :</div>
          <div class="block_con">
            {{ available }}
            <!-- {{
              new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                maximumFractionDigits: 10,
              }).format(available)
            }} -->
            TTOS
          </div>
        </div>
        <div class="block_height">
          <div class="block_tit">TTOS Staked :</div>
          <div class="block_con">
            {{ vertificationStake }}
          </div>
        </div>
        <div class="block_height">
          <div class="block_tit">TTOS Delegated :</div>
          <div class="block_con">
            {{ trustorStake }}
          </div>
        </div>
        <div class="block_height">
          <div class="block_tit">Transactions :</div>
          <div class="block_con">{{ tradeNums }}</div>
        </div>
        <div class="block_height borernone">
          <div class="block_tit" style="margin-top: 20px">Earned Bonus :</div>
          <div class="block_con">
            {{ income }}
            TTOS
          </div>
        </div>
      </div>

      <el-dialog
        title=""
        :visible.sync="dialogVisible"
        width="702px"
        :modal="true"
        :before-close="handleClose"
      >
        <div class="diatit">Account QR Code</div>
        <div class="diaimg" id="qrcode" ref="qrcode"></div>
        <div class="diawallet">Wallet Address</div>
        <div class="diaadress">
          <span>{{ address }}</span>
          <img
            v-clipboard:copy="address"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
            src="@/assets/pc/Index/fz.png"
          />
        </div>
        <span slot="footer" class="dialog-footer">
          <div class="diabton">Save QR Code</div>
          <!-- <el-button type="primary" @click="dialogVisible = false"
            >确 定</el-button> -->
        </span>
      </el-dialog>
    </div>
    <!-- translist start -->
    <div class="translist">
      <!-- <div class="Block_Top notranslate">
        <span class="notranslate">Accounts</span>
      </div> -->
      <div class="resume-list">
        <div class="pool_main">
          <div class="tags">
            <div class="indexList">
              <div class="tabbox">
                <ul>
                  <li :class="num == 1 ? 'active' : ''" @click="qiehuan(1)">
                    Transactions ({{ total }})
                  </li>
                  <li :class="num == 2 ? 'active' : ''" @click="qiehuan(2)">
                    Delegated details
                  </li>
                  <li :class="num == 3 ? 'active' : ''" @click="qiehuan(3)">
                    Tokens ({{ tokenlength }})
                  </li>
                  <li :class="num == 4 ? 'active' : ''" @click="qiehuan(4)">
                    NFTS ({{ total4 }})
                  </li>
                  <li :class="num == 5 ? 'active' : ''" @click="qiehuan(5)">
                    Smart Contracts ({{ list6.length }})
                  </li>
                  <!-- <li :class="num == 6 ? 'active' : ''" @click="qiehuan(6)">
                    Analysis
                  </li> -->
                </ul>
              </div>
            </div>
            <div class="indexContent">
              <div v-show="num == 1">
                <!-- translist start -->

                <div class="resume-list">
                  <div class="pool_main">
                    <div class="tags">
                      <div class="indexList">
                        <div class="Block_list1">
                          <ul class="block_list_Top1">
                            <li>Hash</li>
                            <li>Type</li>
                            <li>Age</li>
                            <li>From</li>
                            <li>To</li>
                            <li>Amount</li>
                          </ul>
                        </div>
                        <div
                          class="Block_List_center1 notranslate"
                          v-show="list2.length > 0"
                        >
                          <ul>
                            <li v-for="(item, index) in list2" :key="index">
                              <p>
                                <span @click="goDetail('transfer', item)">
                                  {{ getSubStr(item.txHash) }}
                                </span>
                              </p>
                              <p>{{ item.type }}</p>
                              <p>
                                {{ item.tradeTime }}
                              </p>
                              <p>
                                <span
                                  @click="
                                    goDetail('address', item.fromAddress1)
                                  "
                                  v-if="
                                    item.type != 'Unstake' &&
                                    item.fromAddress != 'Unpledge' &&
                                    item.fromAddress1 !== address &&
                                    item.type != 'Bonus' &&
                                    item.type != 'Commission' &&
                                    item.type != 'from'
                                  "
                                >
                                  {{ getSubStr2(item.fromAddress) }}
                                </span>
                                <span class="yanca" v-if="item.type == 'Bonus'"
                                  >Bonus</span
                                >
                                <span
                                  class="yanca"
                                  v-if="item.type == 'Commission'"
                                  >Commission</span
                                >
                                <span
                                  v-if="
                                    item.fromAddress1 == address &&
                                    item.type != 'Bonus' &&
                                    item.type != 'Commission'
                                  "
                                  class="yanca"
                                >
                                  {{
                                    (item.type != "Unstake" &&
                                      item.type != "Signature Rewards" &&
                                      item.type != "Bonus") ||
                                    item.type1 == "8"
                                      ? getSubStr2(item.fromAddress)
                                      : "Unstake"
                                  }}
                                </span>
                                <span
                                  v-if="
                                    item.type == 'Unstake' &&
                                    item.fromAddress1 == 'Unpledge'
                                  "
                                  class="yanca"
                                  >Unstake</span
                                >
                                <span
                                  v-if="
                                    item.fromAddress1 == 'Unpledge' &&
                                    item.type == 'Signature Rewards'
                                  "
                                  class="yanca"
                                  >Unstake</span
                                >
                              </p>
                              <p>
                                <span
                                  v-if="
                                    item.type == 'Bonus' ||
                                    item.type == 'Unstake' ||
                                    item.type == 'Withdraw'
                                  "
                                  >{{ getSubStr3(item.toAddress) }}</span
                                >
                                <span>
                                  <span
                                    @click="
                                      goDetail('address', item.toAddress1)
                                    "
                                    :class="
                                      item.toAddress != 'Gas' &&
                                      item.toAddress != 'Stake' &&
                                      item.toAddress1 != address &&
                                      item.toAddress !== ''
                                        ? 'active'
                                        : ''
                                    "
                                    v-if="
                                      (item.type == 'Transfer' ||
                                        item.type == 'Trustor stake' ||
                                        item.type == 'Withdrawal' ||
                                        item.type == 'Delegate' ||
                                        item.type == 'Commission' ||
                                        item.type1 == 'commission' ||
                                        item.type1 == '7' ||
                                        item.type1 == '8') &&
                                      item.toAddress1 !== ''
                                    "
                                    >{{ getSubStr3(item.toAddress) }}</span
                                  >
                                  <span v-if="item.toAddress1 == ''">....</span>
                                </span>
                                <span v-if="item.type == 'Stake'">Stake</span>
                                <span v-if="item.type == 'Signature Rewards'"
                                  >Signature Rewards</span
                                >
                              </p>
                              <p
                                v-if="
                                  item.standard == 'ERC-721' && item.type1 == 7
                                "
                                style="color: #898b8d !important"
                              >
                                <!-- <img :src="item.logo" style="width:24px;height: 24px;" />{{ item.symbol }} #{{
                        item.tokenAmount
                      }} -->
                                <img
                                  :src="item.logo"
                                  style="
                                    width: 24px;
                                    height: 24px;
                                    margin-top: 10px;
                                    /* border: 1px solid red; */
                                    border-radius: 4px;
                                  "
                                />
                                <span v-if="item.contractName == ''">
                                  {{
                                    getSubStr(item.contractAddress, 0, 2)
                                  }}</span
                                >
                                <span v-else>{{ item.contractName }}</span>
                                <!-- 1111  {{ item.contractName }} -->
                              </p>
                              <!-- 代币 -->
                              <p
                                v-if="
                                  item.standard == 'ERC-20' && item.type1 == 7
                                "
                                style="color: #fff !important"
                                @click="cHash1(index)"
                              >
                                <!-- <img :src="item.logo" style="width:24px;height: 24px;" />{{ item.symbol }} #{{
                        item.tokenAmount
                      }} -->
                                <span v-if="item.tokenAmount !== ''">
                                  <!-- {{
                                    Number(item.tokenAmount).toLocaleString()
                                  }} -->
                                  {{ item.tokenAmount }}
                                </span>
                                <img
                                  :src="item.logo"
                                  style="
                                    width: 24px;
                                    height: 24px;
                                    margin-top: 10px;
                                    border-radius: 50%;
                                  "
                                /><span v-if="item.symbol.trim() !== ''">
                                  <span v-if="item.symbol.length > 10"
                                    >{{ item.symbol.slice(0, 10) }}...</span
                                  >
                                  <span v-else>{{ item.symbol }}</span>
                                </span>
                                <span v-else>
                                  <span v-if="item.contractName !== ''">
                                    {{ item.contractName }}
                                  </span>
                                  <span v-else>{{
                                    getSubStr(item.contractAddress, 0, 3)
                                  }}</span>
                                </span>
                              </p>
                              <p
                                v-if="
                                  item.standard == 'ERC-20' && item.type1 == 8
                                "
                                style="color: #fff !important; display: flex"
                                @click="cHash1(index)"
                              >
                                <span v-if="item.tokenAmount !== ''">
                                  <span v-if="item.tokenAmount.length > 8"
                                    >{{ item.tokenAmount.slice(0, 8) }}...</span
                                  >
                                  <span v-else>
                                    <!-- {{
                                      Number(item.tokenAmount).toLocaleString()
                                    }} -->
                                    {{ item.tokenAmount }}
                                  </span>
                                  <!-- {{ item.tokenAmount }} -->
                                </span>
                                <img
                                  :src="item.logo"
                                  style="
                                    width: 24px;
                                    margin-top: 10px;
                                    height: 24px;
                                    border-radius: 50%;
                                  "
                                />
                                <span>{{ item.symbol }}</span>
                                <!-- <img :src="item.logo"  style="width:24px;height: 24px; border-radius: 50%;"/>{{ item.symbol }} #{{
                        item.tokenAmount
                      }} -->
                              </p>
                              <!-- 合约执行 -->
                              <p
                                v-if="
                                  item.standard == 'ERC-721' &&
                                  item.type1 == 8 &&
                                  item.type !== 'balanceOf'
                                "
                              >
                                <!-- //   item.logo -->
                                <img
                                  :src="item.logo"
                                  style="
                                    margin-top: 10px;
                                    height: 24px;
                                    border-radius: 4px;
                                  "
                                /><span
                                  v-if="item.nftNameList !== ''"
                                  @click="cHash(index)"
                                  style="color: #fff; cursor: pointer"
                                  >{{ item.nftNameList }}</span
                                ><span v-else>{{ item.contractName }}</span
                                ><span
                                  v-if="item.tokenAmount !== 0"
                                  @click="cHash(index)"
                                  style="color: #fff; cursor: pointer"
                                  >{{ item.tokenAmount }}</span
                                >
                              </p>
                              <p
                                v-if="
                                  item.standard == 'ERC-721' &&
                                  item.type1 == 8 &&
                                  item.type == 'balanceOf'
                                "
                                style="color: #8d8d8d"
                              >
                                <!-- //   item.logo -->
                                <img
                                  :src="item.logo"
                                  style="
                                    width: 24px;
                                    margin-top: 10px;
                                    height: 24px;
                                    border-radius: 4px;
                                  "
                                />{{ item.contractName }}
                                {{ item.nftNameList }}
                                <span v-if="item.tokenAmount !== ''">
                                  <!-- {{
                                  item.tokenAmount
                                }} -->
                                  <!-- {{
                                    Number(item.tokenAmount).toLocaleString()
                                  }} -->
                                  {{ item.tokenAmount }}
                                </span>
                              </p>
                              <p
                                v-if="
                                  (item.type1 !== 8 || item.type1 !== 7) &&
                                  item.standard == ''
                                "
                                style="color: #898b8d !important"
                              >
                                <!-- {{ Number(item.amount).toLocaleString() }} -->
                                {{
                                  new Intl.NumberFormat("en-US", {
                                    minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                                    maximumFractionDigits: 10,
                                  }).format(item.amount)
                                }}
                                TTOS
                              </p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="block">
                    <el-pagination
                      v-show="list2.length > 0"
                      background
                      small
                      :current-page.sync="pageNum"
                      :page-size="20"
                      :pager-count="5"
                      layout="prev, pager, next"
                      @current-change="handleCurrentChange"
                      :total="total"
                    >
                    </el-pagination>
                  </div>
                  <!-- 当小于长度时候 -->
                  <div class="content_img" v-if="list2.length == 0">
                    <img src="@/assets/m/noseach.png" />
                  </div>
                </div>

                <!-- translist end -->
              </div>
              <div v-show="num == 2">
                <!-- translist start -->

                <div class="resume-list">
                  <div class="pool_main">
                    <div class="tags">
                      <div class="indexList">
                        <div class="Block_list">
                          <ul class="block_list_Top">
                            <li>Investment account (from)</li>
                            <li>Investment account (To)</li>
                            <li>Investment amount</li>
                            <li>Age</li>
                          </ul>
                        </div>
                        <div
                          class="Block_List_center notranslate"
                          v-show="list3.length > 0"
                        >
                          <ul>
                            <li v-for="(item, index) in list3" :key="index">
                              <p
                                v-if="item.fromAddress !== address"
                                @click="goDetail('address', item.fromAddress)"
                              >
                                {{ item.fromAddress1 }}
                              </p>
                              <p v-else style="color: #898b8d">
                                {{ item.fromAddress1 }}
                              </p>
                              <p
                                v-if="item.toAddress !== address"
                                @click="goDetail('address', item.toAddress)"
                              >
                                {{ item.toAddress1 }}
                              </p>
                              <p v-else style="color: #898b8d">
                                {{ item.toAddress1 }}
                              </p>
                              <p>
                                {{
                                  new Intl.NumberFormat("en-US", {
                                    minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                                    maximumFractionDigits: 10,
                                  }).format(item.amount)
                                }}
                                TTOS
                                <!-- {{ Number(item.amount).toLocaleString() }} TTOS -->
                              </p>
                              <p>{{ item.tradeTime }}</p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="block" v-show="list3.length > 0">
                    <el-pagination
                      background
                      small
                      :current-page.sync="pageNum1"
                      :page-size="20"
                      :pager-count="5"
                      layout="prev, pager, next"
                      @current-change="handleCurrentChangea"
                      :total="total3"
                    >
                    </el-pagination>
                  </div>
                  <!-- 当小于长度时候 -->
                  <div class="content_img" v-if="list3.length == 0">
                    <img src="@/assets/m/noseach.png" />
                  </div>
                </div>

                <!-- translist end -->
              </div>
              <div v-show="num == 3">
                <div class="resume-list">
                  <div class="pool_main">
                    <div class="tags">
                      <div class="indexList">
                        <div class="Block_list3">
                          <ul class="block_list_Top3">
                            <li>Asset</li>
                            <li>Contract Address</li>
                            <li>Quantity</li>
                          </ul>
                        </div>
                        <div class="Block_List_center3 notranslate">
                          <ul>
                            <li v-for="(item, index) in list4" :key="index">
                              <p @click="Overview(item.contractAddresss)">
                                <img
                                  :src="item.logo"
                                  style="
                                    width: 24px;
                                    height: 24px;
                                    border-radius: 50%;
                                    margin-top: 8px;
                                  "
                                />
                                {{ item.contractName }}
                              </p>
                              <p @click="Overview(item.contractAddress)">
                                <span>{{ item.contractAddress }}</span>
                              </p>
                              <p>
                                <span v-if="item.balance.length > 10"
                                  >{{ item.balance.slice(0, 10) }}...</span
                                >
                                <span v-else>
                                  {{
                                    new Intl.NumberFormat("en-US", {
                                      minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                                      maximumFractionDigits: 10,
                                    }).format(item.balance)
                                  }}
                                </span>
                              </p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="block" v-if="list4.length > 0">
                    <el-pagination
                      background
                      small
                      :current-page.sync="pageNum"
                      :page-size="20"
                      :pager-count="5"
                      layout="prev, pager, next"
                      @current-change="handleCurrentChange"
                      :total="tokenlength"
                    >
                    </el-pagination>
                  </div>
                  <!-- 当小于长度时候 -->
                  <div class="content_img" v-if="list4.length == 0">
                    <img src="@/assets/m/noseach.png" />
                  </div>
                </div>
              </div>
              <div v-show="num == 4">
                <div class="nftlist">
                  <div
                    class="nft_box"
                    v-for="(item, index) in list5"
                    :key="index"
                  >
                    <div class="nft_img">
                      <img :src="item.image" />
                    </div>
                    <div class="take">
                      Token :<span
                        @click="Tacke(index)"
                        v-if="item.contractName !== ''"
                      >
                        {{ item.contractName }}</span
                      >
                      <span v-else style="cursor: pointer">{{
                        getSubStr(item.contractAddress, 0, 3)
                      }}</span>
                    </div>
                    <div class="takeid" @click="TackeId(index)">
                      TokenID : <span> {{ item.tokenId }}</span>
                    </div>
                  </div>
                </div>
                <div class="block">
                  <el-pagination
                    v-show="list5.length > 0"
                    background
                    small
                    :current-page.sync="pageNum"
                    :page-size="20"
                    :pager-count="5"
                    layout="prev, pager, next"
                    @current-change="handleCurrentChange1"
                    :total="total4"
                  >
                  </el-pagination>
                </div>
                <!-- 当小于长度时候 -->
                <div class="content_img" v-if="list5.length == 0">
                  <img src="@/assets/m/noseach.png" />
                </div>
              </div>
              <div v-show="num == 5">
                <div v-if="this.list6.length > 0">
                  <div class="Contract5">
                    <div class="Contract5_l">Contract :</div>
                    <div class="Contract5_r">
                      <el-select @change="changevale" v-model="selectedOption">
                        <el-option
                          v-for="item in options"
                          :key="item"
                          :label="item"
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <!-- 验证合约开始 -->
                  <div class="yanz" v-if="isChecked == 0">
                    <div class="yanzl">
                      <img :src="imgnamea" />
                      <div>
                        Contract source code is unverified.l am the
                        <br />creator of the contract,<span @click="goto"
                          >Verify and launch source<br />
                          code</span
                        >
                      </div>
                    </div>
                  </div>
                  <!-- 验证成功开始 -->
                  <div class="yanbox" v-if="isChecked == 1">
                    <div class="yanbox1">
                      <img :src="imgname" />
                      <div>Contract Source Code Verified (Exact Match)</div>
                    </div>
                    <div class="yanbox2">
                      <div class="yanbox2t">Contract Name :</div>
                      <div class="yanbox2c">{{ contractName }}</div>
                    </div>
                    <div class="yanbox2">
                      <div class="yanbox2t">Compiler Version :</div>
                      <div class="yanbox2c">{{ allVersion }}</div>
                    </div>
                    <div class="yanbox2">
                      <div class="yanbox2t">License :</div>
                      <div class="yanbox2c">{{ license }}</div>
                    </div>
                  </div>
                  <!-- 验证成功结束 -->
                  <!-- 验证合约结束 -->
                  <div
                    class="Contract5_tit"
                    v-if="code.length > 0 && isChecked == 1"
                  >
                    <div class="Contract5_titl">contract source code</div>
                    <div class="Contract5_titr">
                      <img
                        v-clipboard:copy="code"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                        src="@/assets/pc/charts/copy.png"
                      />
                      <!-- <img src="@/assets/pc/charts/link.png" />
                    <img src="@/assets/pc/charts/fang.png" /> -->
                    </div>
                  </div>
                  <div
                    class="codeEditBox"
                    v-if="code.length > 0 && isChecked == 1"
                  >
                    <editor
                      v-model="code"
                      @init="editorInit"
                      @input="codeChange"
                      lang="javascript"
                      :options="editorOptions"
                      theme="vibrant_ink"
                    ></editor>
                  </div>
                  <div
                    class="Contract5_tit"
                    style="display: flex"
                    v-if="code.length > 0 && isChecked == 1"
                  >
                    <div class="Contract5_titl">Bytecode</div>
                    <div class="Contract5_titr">
                      <img
                        v-clipboard:copy="code1"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                        src="@/assets/pc/charts/copy.png"
                      />

                      <!-- <img src="@/assets/pc/charts/link.png" />
                    <img src="@/assets/pc/charts/fang.png" /> -->
                    </div>
                  </div>
                  <div class="codeEditBox">
                    <editor
                      v-model="code1"
                      @init="editorInit"
                      @input="codeChange"
                      lang="java"
                      :options="editorOptions"
                      theme="vibrant_ink"
                    ></editor>
                  </div>
                </div>
                <!-- 当小于长度时候 -->
                <div class="content_img" v-if="code1 == '' && code == ''">
                  <img src="@/assets/m/noseach.png" />
                </div>
              </div>
              <!-- <div v-show="num == 6">
                <div class="Analysis_list">
                  <div class="charts">
                    <div class="chartshead">
                      <div class="charts_title">TTOS Balance</div>
                      <div class="charts_r">
                        <div class="hombottn" @click="dianji">
                          <div>{{ itemname }}</div>
                          <img :src="ImgUrl" />
                        </div>
                        <div class="headcontent" id="datalist" v-show="valShow">
                          <ul
                            v-for="(item, index) in calendarDatas"
                            :key="index"
                          >
                            <li
                              @click="shuaixuan(item)"
                              :class="index == itemindex ? 'active' : ''"
                            >
                              {{ item.name }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div
                      id="charts"
                      ref="chart"
                      style="width: 350px; height: 180px"
                    ></div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- translist end -->
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import Editor from "vue2-ace-editor";
//黑底色
import "brace/theme/tomorrow_night_eighties";
//蓝底色
import "brace/theme/tomorrow_night_blue";
//黑底色
import "brace/theme/vibrant_ink";
import Seacher from "@/components/m/Seacher.vue";
import { formatSeconds, getSubStr } from "@/utils/utils";
import {
  AddressDetail,
  AddressDetaillist,
  TypeTxsList,
  GetaddressTypeList,
  GettokenList 
} from "@/assets/server/api.js";
import {
  listType,
  countDecimalPlaces,
  formattedNumber,
} from "../../utils/utils.js";

const echarts = require("echarts");
export default {
  components: {
    Seacher,
    Editor,
  },
  data() {
    return {
      tokenlength: "",
      ImgUrl: require("@/assets/m/xialax.png"),
      pageSize: 0,
      total: null,
      total3: null,
      pageNum: 1,
      pageNum1: 1,
      pagerCount: 0,
      income: "",
      available: "",
      available1: "",
      pay: "",
      tradeNums: "",
      vertificationStake: "",
      trustorStake: "",
      TotalBalance: "",
      address: "",
      addressa: "",
      imgname: require("@/assets/pc/TopValidators/TopValidators4.png"),
      imgnamea: require("@/assets/pc/TopValidators/tan.png"),
      transferList: [],
      calendarDatasa: [
        {
          name: "ALL",
          value: "",
          id: 0,
        },
        {
          name: "Transfer",
          value: 1,
          id: 1,
        },
        {
          name: "Bonus",
          value: "toAward",
          id: 2,
        },
        {
          name: "Delegate",
          value: 4,
          id: 3,
        },
        {
          name: "Withdraw",
          value: 5,
          id: 4,
        },
        {
          name: "Stake",
          value: 2,
          id: 5,
        },
        {
          name: "Unstake",
          value: 3,
          id: 6,
        },
        {
          name: "Commission",
          value: "Commission",
          id: 7,
        },
      ],
      IsShow: false,
      dataid: "",
      valShow: false,
      itemindex: 0,
      itemname: "All",
      itemvalue: "",
      itemall: "",
      typeli: 1,
      num: 1,
      //开始
      IsShow: false,
      valShow: false,
      itemname: "1M",
      itemindex: 0,
      imgurl: require("@/assets/pc/Index/indexlogo.png"),
      ImgUrl: require("@/assets/m/home/xiala.png"),
      imgurlnft: require("@/assets/pc/Index/nft.png"),
      calendarDatas: [
        {
          name: "1M",
          value: "",
          id: 0,
        },
        {
          name: "6M",
          value: "",
          id: 1,
        },
        {
          name: "1Y",
          value: "",
          id: 1,
        },
        {
          name: "ALL",
          value: "",
          id: 1,
        },
      ],
      dialogVisible: false,

      list2: [],
      list3: [],
      list4: [],
      list5: [],
      list6: [],
      itemtype: "",
      code: "",
      code1: "",
      editorOptions: {
        wrap: true,
        enableBasicAutocompletion: true, //启用基本自动完成
        enableSnippets: true, // 启用代码段
        enableLiveAutocompletion: true, //启用实时自动完成
        tabSize: 0, //标签大小
        fontSize: 14, //设置字号
        readOnly: true,
        showPrintMargin: false, //去除编辑器里的竖线
        wrapBehavioursEnabled: true, //启用换行
        autoScrollEditorIntoView: false, //启用滚动
        showFoldWidgets: true, // 显示折叠部件
        fadeFoldWidgets: true, // 淡入折叠部件
      },
      options: [],
      selectedOption: null,
      // tfscAddress: "",
      total4: null,
      isChecked: "",
      license: "",
      compileVersion: "",
      allVersion: "",
    };
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  created() {},
  mounted() {
    this.address = this.$route.query.address.split(",")[0];
    if (this.num == 1) {
      this.pageNum = 1;
      this.itemtype = "transactions";
      this.getTransactions();
    } else if (this.num == 2) {
      this.pageNum = 1;
      this.itemtype = "delegatedDetails";
      this.getTransactions();
    } else if (this.num == 3) {
      this.GettokenLists();
    } else if (this.num == 4) {
      this.pageNum = 1;
      this.getNftDetail();
    }
    this.getNftDetail();
    this.getaddressDetail();
    //this.QR();
  },
  watch: {
    deep: true,
    $route(to) {
      this.address = to.query.address.split(",")[0];
      this.pageNum = 1;
      if (this.num == 1) {
        this.pageNum = 1;
        this.itemtype = "transactions";
        this.getTransactions();
      } else if (this.num == 2) {
        this.pageNum = 1;
        this.itemtype = "delegatedDetails";
        this.getTransactions();
      } else if (this.num == 3) {
        this.GettokenLists();
      } else if (this.num == 4) {
        this.pageNum = 1;
        this.getNftDetail();
      }
      this.getaddressDetail();
      //  this.getTransactions();
    },
  },
  destroyed() {},
  methods: {
    goto() {
      this.$router.push("/m/Verify");
      // this.$message("Coming Soon");
    },
    check_is_img(url) {
      return (
        url.match(/\.(jpeg|jpg|gif|png|GIF|PNG|JPG|JPEG|SVG|svg)$/) != null
      );
    },
    Tacke(Index) {
      // console.log(Index);
      let params = {
        contractAddress: this.list5[Index].contractAddress,
      };
      //  console.log(params);
      this.$router.push({ path: "/m/NftOveraddress", query: params });
      // let params = {
      //   address: this.inventoryList[Index].tfscOwner,
      // };
      // console.log(params);
      // this.$router.push({
      //   path: "/m/Address",
      //   query: { address: this.address },
      // });
    },
    TackeId(Index) {
      //   console.log(Index);
      let params = {
        contractAddress: this.list5[Index].contractAddress,
        tokenId: this.list5[Index].tokenId,
      };
      // console.log(params);
      this.$router.push({ path: "/m/NFTslistdetail", query: params });
    },
    Overview(query) {
      this.$router.push({
        path: "/m/Overaddress",
        query: { contractAddress: query },
      });
    },
    cHash1(Index) {
      //   console.log(Index);
      let params = {
        contractAddress: this.list2[Index].contractAddress,
      };
      //    console.log(params);
      this.$router.push({ path: "/m/Overaddress", query: params });
    },
    cHash(Index) {
      //   console.log(Index);
      //  console.log(this.list2[Index]);
      let params = {
        contractAddress: this.list2[Index].contractAddress,
        tokenId: this.list2[Index].tokenAmount.split(",")[0],
      };
      //     console.log(params);
      this.$router.push({ path: "/m/NFTslistdetail", query: params });
    },
    add() {
      let _args = arguments;
      let _pointArray = Array.prototype.map.call(_args, (item) => {
        let _itemArray = item.toString().split(".");
        return _itemArray.length > 1 ? _itemArray[1].length : 0;
      });
      let _maxPoint = Math.max.apply(null, _pointArray);
      let _scale = Math.pow(10, _maxPoint);
      return (
        Array.prototype.reduce.apply(_args, [(a, b) => a + b * _scale, 0]) /
        _scale
      );
    },
    onCopy(e) {
      this.$message({
        message: "Copy successful",
        type: "success",
        center: true,
        duration: "500",
      });
    },
    onError(e) {
      this.$message.error("copy failed");
    },
    QR() {
      this.$nextTick(() => {
        this.QRM();
      });
    },
    //  生成二维码
    QRM() {
      if (this.address != undefined) {
        this.Address = this.address;
        //console.log(this.Address);
      } else {
        this.Address = this.address;
        // console.log(this.Address);
      }
      // console.log("ADdress", Address);
      let qrCode = new QRCode("qrcode", {
        width: 140, //二维码宽度，单位像素
        height: 140, //二维码高度，单位像素
        colorDark: "#000000", //前景色
        colorLight: "#ffffff", //背景色
        correctLevel: QRCode.CorrectLevel.H, //容错级别，
        text: this.Address, //二维码内容：二维码扫描之后访问的地址
      });
      //   console.log(qrCode);
      qrCode.clear(); //清除二维码 。
      qrCode.makeCode(this.Address); //设置二维码内容text，生成另一个新的二维码。
      //    this.qrCodes.clear(); //清除二维码 。
      // this.qrCodes.makeCode(this.Address); //设置二维码内容text，生成另一个新的二维码。
    },
    changevale() {
      //    console.log("Starting search for:", this.selectedOption);
      //  console.log(this.list6);
      for (var i = 0; i < this.list6.length; i++) {
        if (this.selectedOption == this.list6[i].contractAddress) {
          this.code = this.list6[i].sourceCode;
          this.code1 = this.list6[i].byteCode;
          this.isChecked = this.list6[i].isChecked;
          this.license = this.list6[i].licence;
          this.compileVersion = this.list6[i].compileVersion;
          this.allVersion = this.list6[i].allVersion;
          //  this.contractName = this.list6[i].contractName;
          if (this.list6[i].contractName == "") {
            this.contractName = getSubStr(this.list6[i].contractAddress, 0, 6);
          } else {
            this.contractName = this.list6[i].contractName;
          }
        }
      }
      // Your search logic here
    },
    codeChange(val) {
      val;
      //console.log(val)
    },
    editorInit() {
      require("brace/theme/chrome");
      require("brace/ext/language_tools"); //language extension prerequsite...
      require("brace/mode/yaml");
      require("brace/mode/json");
      require("brace/mode/less");
      require("brace/snippets/json");
      require("brace/mode/lua");
      require("brace/snippets/lua");
      require("brace/mode/javascript");
      require("brace/snippets/javascript");
    },
    qiehuan(index) {
      this.num = index;
      if (this.num == 1) {
        this.pageNum = 1;
        this.itemtype = "transactions";
        this.getTransactions();
      } else if (this.num == 2) {
        this.pageNum = 1;
        this.itemtype = "delegatedDetails";
        this.getTransactions();
      } else if (this.num == 3) {
        this.GettokenLists();
      } else if (this.num == 4) {
        this.pageNum = 1;
        this.getNftDetail();
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    shuaixuan() {},
    dianji() {
      if (this.IsShow == false) {
        this.IsShow = true;
        this.valShow = true;
        this.ImgUrl = require("@/assets/m/home/xiala.png");
      } else if (this.IsShow == true) {
        this.IsShow = false;
        this.valShow = false;
        this.ImgUrl = require("@/assets/m/home/shang.png");
      }
    },
    initCharts() {
      this.lineChart = echarts.init(this.$refs.chart);
      let option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(36,41,49,0.8)", //设置背景图片 rgba格式
          color: "rgba(255, 255, 255, 0.5)",
          formatter: function (params) {
            let str =
              '<span style="color:#fff;font-size:12px;">' +
              params[0].name +
              "(UTC)" +
              "</span>" +
              "</br>" +
              "<div style='display:flex;'>" +
              "<span style=' width:6px;height:6px;margin-top:10px;margin-right:4px; border-radius:10px;display:block;background:#00CB87;'></span>" +
              "<span style='color:#fff'>Balance :</span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
              params[0].value +
              "</span>" +
              "</div>";
            return str;
          },
        },
        // legend: {
        //   data: ["Email", "Union Ads", "Video Ads", "Direct", "Search Engine"],
        // },
        grid: {
          top: "8%",
          left: "2%",
          right: "0%",
          bottom: "0%",
          containLabel: true,
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {},
        //   },
        // },
        xAxis: {
          type: "category",
          show: true,
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          axisLine: {
            show: false, //隐藏x轴线
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false, //隐藏x轴刻度
          },
        },
        yAxis: {
          type: "value",
          show: true,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#00E79A",
                },
                {
                  offset: 0,
                  color: "#00E79A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(146, 169, 255, 100)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#00E79A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: [820, 932, 901, 934, 1290, 1330, 1320],
          },
        ],
      };
      this.lineChart.setOption(option);
    },
    async getNftDetail() {
      let formData = new FormData();
      let params = {
        address: this.address,
        pageNum: this.pageNum,
        pageSize: 20,
      };
      //   console.log(params);
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await AddressDetaillist(formData);
      //   console.log(res);
      this.total4 = res.result.nftCount;
      this.list5 = res.result.nftList;
      //     console.log(this.list5);
      for (var i = 0; i < this.list5.length; i++) {
        // this.list5[i].image
        if (this.list5[i].image == "") {
          this.list5[i].image = this.imgurlnft;
        }
      }
    },
    searchs(e) {
      this.pageNum = 1;
      this.address = e.address;
      this.getaddressDetail();
      this.getTransactions();
    },
    async GettokenLists() {
      let formData = new FormData();
      let params = {
        address: this.address,

        pageNum: this.pageNum,
        pageSize: 20,
      };
      //     console.log(params);
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await GettokenList(formData);
      console.log(res);
      this.list4 = res.result;
      this.tokenlength = res.result.length;
      // console.log(this.list4);
      for (var i = 0; i < this.list4.length; i++) {
        if (this.list4[i].logo == "") {
          this.list4[i].logo = this.imgurl;
        }
        if (this.list4[i].contractName == "") {
          this.list4[i].contractName = this.list4[i].symbol;
        }
      }
    },
    async getTransactions() {
      if (this.num == 1) {
        this.pageNum = this.pageNum;
        //this.itemtype = "transactions";
      } else if (this.num == 2) {
        this.pageNum = this.pageNum1;
        // this.itemtype = "delegatedDetails";
      }
      //    console.log(this.num);
      // if (this.num == 1) {
      //   this.itemtype = "transactions";
      // } else if (this.num == 2) {
      //   this.itemtype = "delegatedDetails";
      // }
      let formData = new FormData();
      let params = {
        address: this.address,
        listType: this.itemtype,
        pageNum: this.pageNum,
        pageSize: 20,
      };
      //     console.log(params);
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await GetaddressTypeList(formData);
      //     console.log(res);
      var calctime = new Date();
      //let strdate = Math.floor(calctimea.getTime() / 1000);
      let strdate = Math.floor(calctime.getTime() / 1000);
      if (this.num == 1) {
        // var res = await GetaddressTypeList(formData);
        this.list2 = res.result.list;
        //       console.log(this.list2);
        this.total = res.result.count;
        //       console.log(this.total);

        for (var i = 0; i < this.list2.length; i++) {
          this.list2[i].tokenAmount = formattedNumber(
            this.list2[i].tokenAmount
          );
          if (this.list2[i].logo == "") {
            this.list2[i].logo = this.imgurl;
          }
          this.list2[i].txHash1 = getSubStr(this.list2[i].txHash, 0, 6);

          let timestamp = Math.floor(
            this.gltimea(this.list2[i].tradeTime) / 1000
          );
          var s = strdate - timestamp;
          if (s <= 0) {
            s = 1;
          }
          this.list2[i].tradeTime = formatSeconds(s);
          this.list2[i].type1 = this.list2[i].type;
          if (
            this.list2[i].standard == "ERC-721" &&
            this.list2[i].nftImageList !== "" &&
            this.list2[i].type == 8
          ) {
            var images = JSON.parse(this.list2[i].nftImageList);
            // console.log(images);
            this.list2[i].logo = images[0];
            // if (this.check_is_img(this.list2[i].logo) == false) {
            //   this.list2[i].logo = this.imgurl1;
            // }
            // this.list2[i].logo = this.imgurl1;
          } else {
            if (
              this.list2[i].standard == "ERC-721" &&
              this.list2[i].type == 8
            ) {
              this.list2[i].logo = this.imgurlnft;
            }
          }
          // if(this.list2[i].logo=='' || this.check_is_img(this.list2[i].logo)==false){
          //   console.log(111);
          //   this.list2[i].logo = this.imgurlnft;
          // }
          if (this.list2[i].nftNameList !== "") {
            this.list2[i].nftNameList = JSON.parse(
              this.list2[i].nftNameList
            )[0];
          }
          if (this.list2[i].type == "mint") {
            this.list2[i].tokenAmount = this.list2[i].tokenAmount.split(",")[0];
          } else {
            // if (countDecimalPlaces(this.list2[i].tokenAmount) > 8) {
            //   this.list2[i].tokenAmount = Number(
            //     this.list2[i].tokenAmount
            //       .split(",")[0]
            //       .toString()
            //       .match(/^\d+(?:\.\d{0,8})?/)
            //   );
            // }
          }
          //   this.list2[i].tokenAmount = this.list2[i].tokenAmount.split(",")[0];
          // if(this.list2[i].fromAddress=='' || this.list2[i].toAddress==''){
          //   this.list2[i].fromAddress=='...'
          // }
          if (this.list2[i].type1 == "8") {
            //         console.log("888888");
            this.list2[i].type = this.list2[i].functions;
          }
          if (this.list2[i].type1 == "8") {
            //        console.log("99999999");
            this.list2[i].fromAddress = this.list2[i].fromEvmAddress;
            this.list2[i].toAddress = this.list2[i].toEvmAddress;
          }
          this.list2[i].fromAddress1 = this.list2[i].fromAddress;
          this.list2[i].toAddress1 = this.list2[i].toAddress;
          this.list2[i].fromAddress = getSubStr(
            this.list2[i].fromAddress,
            0,
            6
          );
          if (this.list2[i].type == "mint") {
            this.list2[i].tokenAmount = this.list2[i].tokenAmount.split(",")[0];
          } else {
            // if (countDecimalPlaces(this.list2[i].tokenAmount) > 8) {
            //   this.list2[i].tokenAmount = Number(
            //     this.list2[i].tokenAmount
            //       .split(",")[0]
            //       .toString()
            //       .match(/^\d+(?:\.\d{0,8})?/)
            //   );
            // }
          }
          this.list2[i].toAddress = getSubStr(this.list2[i].toAddress, 0, 6);
          this.list2[i].type = listType(this.list2[i].type);
          if (this.list2[i].standard !== "ERC-20" && this.list2[i].logo == "") {
            if (this.list2[i].type1 == 7) {
              this.list2[i].logo = this.imgurl;
            } else {
              this.list2[i].logo = this.imgurlnft;
            }
          }
          if (
            this.list2[i].standard == "ERC-20" &&
            (this.list2[i].logo == "" ||
              this.check_is_img(this.list2[i].logo) == false)
          ) {
            // this.list2[i].logo = this.imgurl;
            if (this.list2[i].logo !== "") {
              this.list2[i].logo = this.list2[i].logo;
            } else {
              this.list2[i].logo = this.imgurl;
            }
          }

          //类型为8 ERC-20的时候
          if (this.list2[i].standard == "ERC-20" || this.list2[i].type1 == 8) {
            if (this.list2[i].symbol.trim() == "") {
              if (this.list2[i].contractName.trim() !== "") {
                this.list2[i].symbol = this.list2[i].contractName;
              } else {
                this.list2[i].symbol = getSubStr(
                  this.list2[i].contractAddress,
                  0,
                  3
                );
              }
            }
          }
          //类型为7 ERC-20的时候
        }
      } else if (this.num == 2) {
        this.list3 = res.result.list;
        this.total3 = res.result.count;
        for (var i = 0; i < this.list3.length; i++) {
          this.list3[i].fromAddress1 = getSubStr(
            this.list3[i].fromAddress,
            0,
            6
          );
          this.list3[i].toAddress1 = getSubStr(this.list3[i].toAddress, 0, 6);
          let timestamp = Math.floor(
            this.gltimea(this.list3[i].tradeTime) / 1000
          );
          var s = strdate - timestamp;
          if (s <= 0) {
            s = 1;
          }
          this.list3[i].tradeTime = formatSeconds(s);
        }
      }
    },

    async getaddressDetail() {
      this.typeli = 1;
      let formData = new FormData();
      let params = {
        address: this.address,
        // pageNum: this.pageNum,
        // pageSize: 10,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await AddressDetail(formData);
      //  console.log(res);
      this.tokenlength = res.result.tokenCount;
      //  this.tfscAddress = res.result.tfscAddress;
      this.available = formattedNumber(res.result.available);
      let ccc = this.add(res.result.available, res.result.tfscStaked);
      let TotalBalance = this.add(ccc, res.result.tfscDelegated);
      // TotalBalance = TotalBalance.toFixed(8);
      this.available1 = formattedNumber(TotalBalance) + " TTOS";

      this.vertificationStake = formattedNumber(res.result.tfscStaked);
      this.trustorStake = formattedNumber(res.result.tfscDelegated);
      this.tradeNums = formattedNumber(res.result.txCount);
      // this.income = res.result.earnedBonus;
      if (res.result.earnedBonus == "0.00") {
        this.income = 0;
      } else {
        this.income = formattedNumber(res.result.earnedBonus);
      }
      // this.list4 = res.result.tokenList;
      // for (var i = 0; i < this.list4.length; i++) {
      //   if (this.list4[i].logo == "") {
      //     this.list4[i].logo = this.imgurl;
      //   }
      //   if (this.list4[i].contractName == "") {
      //     this.list4[i].contractName = this.list4[i].symbol;
      //   }
      // }
      //     console.log(this.list4);
      // this.list5 = res.result.nftList;
      // console.log(this.list5);
      this.list6 = res.result.contractList;
      this.options = [];
      //     console.log(this.list6);
      if (this.list6.length > 0) {
        this.selectedOption = this.list6[this.list6.length - 1].contractAddress;
        for (var i = 0; i < this.list6.length; i++) {
          this.options.push(this.list6[i].contractAddress);
          this.code = this.list6[i].sourceCode;
          this.code1 = this.list6[i].byteCode;
          this.isChecked = this.list6[i].isChecked;
          //     console.log(this.isChecked);
          this.license = this.list6[i].licence;
          if (this.list6[i].contractName.trim() == "") {
            this.contractName = getSubStr(this.list6[i].contractAddress, 0, 6);
          } else {
            this.contractName = this.list6[i].contractName;
          }

          this.compileVersion = this.list6[i].compileVersion;
          this.allVersion = this.list6[i].allVersion;
          //  this.contractName = this.list6[i].contractName;
        }
        //  console.log(this.code);
        //  console.log(this.code1);
        // this.code = JSON.stringify(this.list6[2].sourceCode, null, 2); // 格式化
        // console.log(this.code);
      }
    },
    handleCurrentChangea(currentPage) {
      this.pageNum = currentPage;
      this.getTransactions();
    },
    handleCurrentChange(currentPage) {
      this.pageNum = currentPage;
      this.getTransactions();
      this.getaddressDetail();
      // if (this.typeli == 1) {
      //   this.getaddressDetail();
      // } else if (this.typeli == 2) {
      //   this.shuaixuan(this.itemall);
      // }
    },
    handleCurrentChange1(currentPage) {
      this.pageNum = currentPage;
      this.getNftDetail();
    },
    copyClicked(e) {
      this.$message.success({
        type: "info",
        message: "Content copied to clipboard!",
        center: true,
        duration: "500",
      });
    },
    onError(e) {
      this.$message.error("Sorry, copy failed！");
    },
    getSubStr(str) {
      var subStr1 = str.substr(0, 5);
      var subStr2 = str.substr(str.length - 5, 5);
      var subStr = subStr1 + "..." + subStr2;
      return subStr;
    },
    getSubStr2(str) {
      var subStr1 = str.substr(0, 5);
      var subStr2 = str.substr(str.length - 5, 5);
      var subStr = subStr1 + "..." + subStr2;
      return subStr;
    },
    getSubStr3(str) {
      var subStr1 = str.substr(0, 5);
      var subStr2 = str.substr(str.length - 5, 5);
      var subStr = subStr1 + "..." + subStr2;
      return subStr;
    },
    goDetail(name, query) {
      this.pageNum = 1;

      this.ImgUrl = require("@/assets/m/xialax.png");
      switch (name) {
        case "address":
          this.$router.push({
            path: "/m/Address",
            query: { address: query },
          });
          this.address = this.$route.query.address;
          break;
        case "transfer":
          this.$router.push({
            path: "/m/TransferDetails",
            query: {
              txHash: query.txHash,
              type: query.type1,
              standard: query.standard,
            },
          });
          break;
        case "hash":
          this.$router.push({
            path: "/m/TransferDetails",
            query: { txHash: query },
          });
          break;
        case "height":
          this.$router.push({
            path: "/m/BlockList",
            query: { id: query },
          });
          break;
      }
    },

    gltimea(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },
  },
};
</script>
<style>
.ace_layer {
  min-height: 500px !important;
  padding-bottom: 10px;
}
.yanca {
  color: #898b8d;
}
.ace_gutter-cell.ace_error {
  background-image: none !important;
}
.ace_gutter-cell.ace_warning {
  background-image: none !important;
}
.el-icon-arrow-up:before {
  color: #ffffff;
  font-weight: 900;
}
.el-popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #000 !important;
}
.el-select-dropdown__item.selected {
  font-family: Roboto-Regular, Roboto;
  font-weight: 400;
  color: #00ffaa;
  background: #1b1e24 !important;
  border-radius: 6px 6px 6px 6px;
  opacity: 1;
}
.el-select-dropdown__list {
  width: 501px;

  background: #13161b;
  border-radius: 16px 16px 16px 16px;
  opacity: 1;

  /* border: none !important; */
}
.el-input__inner {
  background: none;
  border: none;
  color: #fff;
}
.el-select-dropdown {
  border: none !important;
}

.el-select-dropdown__item {
  font-family: Roboto-Regular, Roboto;
  font-weight: 400;
  color: #ffffff;
}
.el-select-dropdown__item.hover {
  background: #000;
}
.el-popper[x-placement^="bottom"] .popper__arrow::after {
  background: #1c1e24 !important;
  border-style: none;
}
::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 20px;
  height: 6px;
  /* border-radius: 24px; */
  background: #13161b;
}
::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 0;
}
::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 25px;

  background: #404040;
  transition: color 0.2s ease;
}
::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

.codeEditBox {
  width: 690px;
  margin: 0 auto;
  height: 500px;
  margin-top: 20px;
  background: #0b0c0f;
  border-radius: 10px 10px 10px 10px;
  opacity: 1;
}
</style>
<style lang="less">
.v-modal {
  opacity: 0.8 !important;
  background: #13161b !important;
}
.el-dialog__footer {
  padding-left: 24px !important;
}
.el-dialog {
  width: 702px !important;
  background: #000000;
}

.el-message {
  margin-top: 120px !important;
}
.el-select-dropdown__list {
  padding: 0px 10px;
}
.el-select-dropdown__item.selected {
  background: none !important;
}
.el-select-dropdown__item {
  border-bottom: 1px solid rgba(255, 255, 255, 0.16);
}
.el-select-dropdown__item:last-child {
  border-bottom: none;
}
.el-scrollbar__wrap {
  margin: 0px !important;
  background: none !important;
}
.el-select-dropdown {
  background: none !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #22252e;
  color: #fff;
  font-size: 24px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 400;
  border: none;
}
.el-pager li {
  margin: 0px 6px !important;
  padding: 0px 6px !important;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev {
  background: none;
  color: #fff !important;
  width: 10px !important;
}

.el-pagination.is-background .el-pager li {
  padding-left: 6px;
  padding-right: 6px;
  height: 48px;
  margin: 0 10px;
  //background: #3c485c;
  background: none;
  border-radius: 8px;
  opacity: 1;
  font-size: 24px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 400;
  color: #ffffff !important;
  line-height: 48px;
  text-align: center;
}
</style>
<style lang="less" scoped>
.ace_gutter-layer {
  background: #0b0c0f !important;
}
.el-pagination {
  padding-bottom: 32px !important;
  margin-top: 32px;
}
.indexs {
  width: 750px;
  margin: 110px auto 0px auto;
  background: #13161b;
  text-align: center;
  .content_top {
    margin: 30px auto 0px auto;
    width: 702px;
    background: #0b0c0f;
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    .diatit {
      // color: red;
      font-size: 40px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 56px;
    }
    .diaimg {
      width: 280px;
      height: 280px;

      margin: 0 auto;
      margin-top: 60px;
    }
    .diawallet {
      height: 36px;
      font-size: 26px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #898b8d;
      line-height: 36px;
      text-align: left;
      margin-top: 60px;
    }
    .diaadress {
      display: flex;
      margin-top: 20px;
      span {
        font-size: 24px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        word-spacing: -1px;
      }
      img {
        width: 60px;
        height: 60px;
        margin-left: 10px;
        margin-top: -6px;
      }
    }
    .diabton {
      width: 654px;
      height: 110px;
      line-height: 110px;
      background: #00e79a;
      border-radius: 16px 16px 16px 16px;
      opacity: 1;
      margin: 0 auto;
      text-align: center;
      font-size: 40px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
    }
  }
  .head {
    width: 702px;
    padding: 24px 12px;
    // margin:32px 0 32px 32px;
    background: #0b0c0f;
    opacity: 1;
    border-radius: 16px 16px 16px 16px;
    padding-left: 30px;
    text-align: left;
    height: 48px;
    font-size: 32px;
    font-family: SF Pro Text-Medium, SF Pro Text;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    line-height: 48px;
    span {
      font-size: 26px;
      font-family: "PingFang SC-中黑体, PingFang SC";
      font-weight: normal;
      color: #b2b7c2;
      line-height: 36px;
    }
  }
  .content_center {
    text-align: left;
    padding: 40px 0px 10px 0px;
    font-size: 26px;
    font-family: SF Pro Text-Medium, SF Pro Text;
    font-weight: normal;
    color: #adb0c7;
    // line-height: 36px;
    // border-bottom: 1px solid #3c485c;
    margin: 0px 32px;
    .borernone {
      border-bottom: none !important;
      // border:1px solid red;
    }
    .bkheight {
      height: 110px !important;
    }
    .block_height {
      height: 100px;
      margin-top: 28px;
      border-bottom: 1px solid #22252e;
      .block_tit {
        font-size: 26px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #8a8a8a;
        height: 36px;
        line-height: 36px;
      }
      .block_con {
        font-size: 26px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #8a8a8a;
        height: 36px;
        line-height: 36px;
        margin-top: 12px;
        display: flex;
        .block_hasha {
          width: 334px;
          height: 72px;
          font-size: 26px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #8a8a8a;
          line-height: 36px;
          word-wrap: break-word;
          margin-right: 160px;
        }
        .block_hash {
          width: 565px;
          height: 72px;
          font-size: 26px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #8a8a8a;
          line-height: 36px;
          word-wrap: break-word;
        }
        img {
          width: 60px;
          height: 60px;
          margin-left: 10px;
        }
      }
    }
  }
  .translist {
    width: 100%;
    overflow: hidden;
    margin-top: 24px;
    background: #13161b;
    .Block_Top {
      text-align: left;
      width: 702px;
      height: 80px;
      line-height: 80px;
      margin: 0 auto;
      background: #0b0c0f;
      border-radius: 24px 24px 0 0;
      span {
        font-size: 30px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        margin-left: 24px;
      }
      b {
        margin-left: 10px;
      }
    }
    //轮播图片开始
    .resume-list {
      width: 702px;
      background: #0b0c0f;
      border-radius: 0 0 24px 24px;
      margin: 0 auto;
      .pool_main {
        width: 100%;
      }
      .tags {
        //display: flex;
        overflow: auto;
        white-space: nowrap;
      }
      //隐藏滚动条
      .tags::-webkit-scrollbar {
        display: none;
      }
      // 列表开始
      .indexList {
        // width: 100%;
        margin: 0;
        padding: 0;
        background: #0b0c0f;
        // overflow: hidden;
        // border: 1px solid red;
        width: 702px;
        .tabbox {
          display: flex;
          height: 90px;
          margin-top: 24px;
          margin-left: 24px;
          margin-bottom: 24px;
          overflow: hidden;
          ul::-webkit-scrollbar {
            display: none;
          }
          ul {
            overflow: auto;
            display: flex;
            li {
              // width: 271px;
              padding-left: 24px;
              padding-right: 24px;
              height: 80px;
              line-height: 80px;
              background: #000000;
              margin-right: 24px;
              opacity: 1;
              border: 4px solid;
              border-radius: 24px 24px 24px 24px;
              font-size: 26px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #898b8d;
            }
            .active {
              // width: 254px;
              height: 80px;
              background: linear-gradient(124deg, #324c43 0%, #0d402f 100%);
              border-radius: 16px 16px 16px 16px;
              opacity: 1;

              font-size: 26px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #00ffaa;
              line-height: 80px;
              text-align: center;
            }
          }
        }
      }
      .indexContent {
        overflow: hidden;
        .Contractit {
          display: flex;
          height: 42px;
          font-size: 30px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #898b8d;
          line-height: 42px;
          margin-left: 24px;
          .Contrat {
            height: 42px;
            font-size: 30px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #898b8d;
            line-height: 42px;
          }
          .Contrac {
            height: 42px;
            font-size: 30px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 42px;
            margin-left: 24px;
          }
        }
        .Contracoent {
          height: 42px;
          font-size: 30px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 42px;
          text-align: left;
          margin-left: 24px;
          margin-top: 44px;
        }
        .Contrac_img {
          margin-left: 410px;
          margin-bottom: 24px;
          img {
            width: 60px;
            height: 60px;
            margin-right: 44px;
          }
        }
        .Contrant {
          width: 654px;
          height: 624px;
          background: #13161b;
          border-radius: 16px 16px 16px 16px;
          opacity: 1;
          margin: 0 auto;
          overflow: hidden;
        }
        .Block_list1 {
          .block_list_Top1 {
            display: flex;
            width: 1800px;
            height: 82px;
            line-height: 82px;
            background: #13161b;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            li {
              font-size: 28px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              height: 82px;
              line-height: 82px;
              -webkit-background-clip: text;
              // flex: 0 0 14%;
              text-align: left;
            }
            li:nth-child(1) {
              // border: 1px solid red;
              margin-left: 24px;
              width: 250px;
            }
            li:nth-child(2) {
              width: 250px;
            }
            li:nth-child(3) {
              width: 400px;
            }
            li:nth-child(4) {
              width: 300px;
            }
            li:nth-child(5) {
              width: 300px;
            }
            li:nth-child(6) {
              width: 300px;
            }
          }
        }
        .Block_List_center1 {
          width: 1800px;
          ul {
            //  height: 620px;
            width: 1800px;
            margin: 0;
            padding: 0;
            //padding: 0 19px;
            li {
              display: flex;
              height: 82px;
              border-bottom: 1px solid #22252e;
              line-height: 82px;
              margin-left: 24px;
              // width: 200px;
              p {
                font-size: 26px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;

                text-align: left;
                img {
                  border-radius: 50%;
                  margin-left: 4px;
                  margin-right: 4px;
                }
                .active {
                  color: #fff;
                }
                // .yanca{
                //   color: red;
                // }
                // flex: 0 0 14%;
              }
            }
            li:last-child {
              border-bottom: none;
            }
            p {
              font-size: 26px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
            }
            p:nth-child(1) {
              width: 250px;
              color: #ffffff;
              cursor: pointer;
            }
            p:nth-child(2) {
              width: 250px;
              color: #8a8a8a;
            }
            p:nth-child(3) {
              width: 400px;
              color: #8a8a8a;
            }
            p:nth-child(4) {
              width: 300px;
              color: #fff;
            }
            p:nth-child(5) {
              width: 300px;
              // color: #fff;
              color: #8a8a8a;
            }
            p:nth-child(6) {
              width: 300px;
              color: #8a8a8a;
            }
          }
        }
        .Block_list {
          .block_list_Top {
            display: flex;
            width: 1600px;
            height: 82px;
            line-height: 82px;
            background: #13161b;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            li {
              font-size: 28px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              height: 82px;
              line-height: 82px;
              -webkit-background-clip: text;
              // flex: 0 0 14%;
              text-align: left;
            }
            li:nth-child(1) {
              // border: 1px solid red;
              margin-left: 24px;
              width: 400px;
            }
            li:nth-child(2) {
              width: 400px;
            }
            li:nth-child(3) {
              width: 400px;
            }
            li:nth-child(4) {
              width: 400px;
            }
          }
        }
        .Block_List_center {
          width: 1600px;
          ul {
            //  height: 620px;
            width: 1600px;
            margin: 0;
            padding: 0;
            //padding: 0 19px;
            li {
              display: flex;
              height: 82px;
              border-bottom: 1px solid #22252e;
              line-height: 82px;
              margin-left: 24px;
              // width: 200px;
              p {
                font-size: 26px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                text-align: left;
                // flex: 0 0 14%;
              }
            }
            li:last-child {
              border-bottom: none;
            }
            p:nth-child(1) {
              width: 400px;
              // border: 1px solid red;
            }
            p:nth-child(2) {
              width: 400px;
            }
            p:nth-child(3) {
              width: 400px;
              color: #8a8a8a;
            }
            p:nth-child(4) {
              width: 400px;
              color: #8a8a8a;
            }
          }
        }
        .Block_list3 {
          .block_list_Top3 {
            display: flex;
            width: 1200px;
            height: 82px;
            line-height: 82px;
            background: #13161b;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            li {
              font-size: 28px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              height: 82px;
              line-height: 82px;
              -webkit-background-clip: text;
              // flex: 0 0 14%;
              text-align: left;
            }
            li:nth-child(1) {
              // border: 1px solid red;
              margin-left: 24px;
              width: 300px;
            }
            li:nth-child(2) {
              width: 500px;
            }
            li:nth-child(3) {
              width: 400px;
            }
          }
        }
        .Block_List_center3 {
          width: 1200px;
          ul {
            //  height: 620px;
            width: 1200px;
            margin: 0;
            padding: 0;
            //padding: 0 19px;
            li {
              display: flex;
              height: 82px;
              border-bottom: 1px solid #22252e;
              line-height: 82px;
              margin-left: 24px;
              // width: 200px;
              p {
                font-size: 26px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                text-align: left;
                // flex: 0 0 14%;
                img {
                  width: 60px;
                  height: 60px;
                  border-radius: 50%;
                  // margin-top: -2 px;
                  // border: 1px solid red;
                }
              }
            }
            li:last-child {
              border-bottom: none;
            }
            p:nth-child(1) {
              width: 280px;
              line-height: 82px;
              // border: 1px solid red;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
              padding-right: 20px;
            }
            p:nth-child(2) {
              width: 500px;
              overflow: hidden;
              line-height: 82px;
              // border: 1px solid red;
              white-space: nowrap;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
              span {
                display: block;
                width: 300px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
              }
            }
            p:nth-child(3) {
              width: 400px;
              color: #8a8a8a;
            }
          }
        }
        .nftlist {
          width: 702px;
          margin: 0 auto;
          overflow: hidden;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          // margin-left: 24px;
          .nft_box {
            //  margin-left: 12px;
            //  margin-right: 12px;
            //  margin-top: 34px;
            margin: 34px 12px;
            text-align: left;
            // margin: 34px 24px;
            .nft_img {
              width: 315px;
              // height: 392px;
              // background: #0052fe;
              border-radius: 16px 16px 16px 16px;
              opacity: 1;
              img {
                width: 315px;
                // height: 392px;
                // background: #0052fe;
                border-radius: 16px 16px 16px 16px;
              }
            }
            .take {
              height: 34px;
              font-size: 24px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              line-height: 34px;
              margin-top: 24px;
              span {
                color: #fff;
              }
            }
            .takeid {
              margin-top: 16px;
              height: 34px;
              font-size: 24px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              line-height: 34px;
              span {
                color: #fff;
              }
            }
          }
        }
        // 第四部分开始
        .yanz {
          width: 678px;
          height: 175px;
          opacity: 1;
          border-bottom: 1px solid #22252e;
          border-top: 1px solid #22252e;
          .yanzl {
            display: flex;
            margin-left: 28px;
            margin-top: 28px;
            img {
              width: 48px;
              height: 48px;
            }
            div {
              margin-left: 12px;
              word-wrap: break-word;
              word-break: break-all;
              text-align: left;
              font-size: 26px;
              font-family: Source Han Sans-Regular, Source Han Sans;
              font-weight: 400;
              color: #898b8d;
              line-height: 38px;
              span {
                color: #fff;
              }
            }
          }
        }
        .yanbox {
          width: 678px;
          .yanbox1 {
            display: flex;
            margin-left: 28px;
            padding-top: 28px;
            border-top: 1px solid #22252e;
            padding-bottom: 28px;
            border-bottom: 1px solid #22252e;
            img {
              width: 40px;
              height: 40px;
              margin-right: 12px;
            }
            div {
              font-size: 26px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #898b8d;
              line-height: 38px;
            }
          }
          .yanbox2 {
            border-bottom: 1px solid #22252e;
            height: 120px;
            text-align: left;
            width: 678px;
            // border: 1px solid yellow;

            .yanbox2t {
              margin-left: 28px;
              margin-top: 28px;
              height: 36px;
              font-size: 26px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              line-height: 36px;
            }
            .yanbox2c {
              margin-left: 28px;
              // height: 36px;
              font-size: 26px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #898b8d;
              // line-height: 36px;
              margin-top: 12px;
              width: 640px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              //   border: 1px solid red;
              // //  word-wrap: break-word;
              //   word-break: break-all;
              //   overflow-wrap: break-word;
              //   display: inline-block;
              // overflow: hidden;
            }
          }
        }
        .Contract5 {
          width: 1080px;
          margin: 0 auto;
          display: flex;

          background: #0b0c0f;
          border-radius: 10px 10px 10px 10px;
          opacity: 1;
          .Contract5_l {
            margin-left: 30px;
            margin-top: 20px;
            font-size: 28px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #898b8d;
          }
          .Contract5_r {
          }
        }
        .Contract5_tit {
          margin-top: 28px;
          display: flex;
          justify-content: space-between;
          .Contract5_titl {
            height: 26px;
            font-size: 26px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
            line-height: 26px;
            margin-left: 40px;
          }
          .Contract5_titr {
            //margin-right: 40px;
            img {
              width: 48px;
              height: 48px;
              margin-right: 14px;
              // border: 1px solid red;
            }
          }
        }
        // 第四部分结束
        .Analysis_list {
          width: 654px;
          height: 445px;
          background: #13161b;
          border-radius: 16px 16px 16px 16px;
          //border: 1px solid red;
          opacity: 1;
          margin: 0 auto;
          margin-bottom: 40px;
          .charts {
            .chartshead {
              display: flex;
              justify-content: space-between;
              .charts_title {
                height: 42px;
                font-size: 30px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #898b8d;
                line-height: 42px;
                margin-top: 24px;
                margin-left: 24px;
              }
              .charts_r {
                position: relative;
                top: 28px;
                left: 10px;
                .hombottn {
                  z-index: 99;
                  display: flex;
                  width: 100px;
                  height: 44px;
                  background: #242931;
                  border-radius: 13px 13px 13px 13px;
                  opacity: 1;
                  // margin-top: 20px;
                  margin-right: 20px;
                  div {
                    height: 17px;
                    height: 34px;
                    font-size: 24px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #ffffff;
                    line-height: 34px;
                    margin-top: 4px;
                    margin-left: 20px;
                  }
                  img {
                    width: 40px;
                    height: 40px;
                    // margin-top: 5px;
                    margin-left: 2px;
                  }
                }
                .headcontent {
                  width: 100px;
                  height: 108px;
                  background: #15171a;
                  border-radius: 6px 6px 6px 6px;
                  opacity: 1;
                  position: absolute;
                  left: 0px;
                  top: 64px;
                  z-index: 88;
                  ul {
                    // margin: 12px;
                    margin-left: 12px;
                    li:nth-child(1) {
                      margin-top: 5px;
                    }
                    li {
                      height: 21px;
                      line-height: 21px;
                      cursor: pointer;
                      font-size: 12px;
                      font-family: Source Han Sans CN-Regular,
                        Source Han Sans CN;
                      font-weight: 400;
                      color: #8e9093;
                    }
                    .active {
                      cursor: pointer;
                      color: #00a870;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .block {
        margin-top: 70px;
        padding-bottom: 70px;
        font-size: 28px;
        font-family: "PingFang SC-中黑体, PingFang SC";
        font-weight: normal;
        color: #adb0c7;
        // line-height: 39px;
      }
    }

    //轮播图片结束
  }
  .list {
    text-align: center;
    padding-bottom: 80px;
  }
  .list-data {
    margin: 30px auto 0px auto;
    width: 690px;
    background: #232a35;
    border-radius: 16px 16px 16px 16px;
    opacity: 1;
    .block {
      height: 128px;
      margin-top: 51px;
      margin-bottom: 50px;
      font-size: 28px;
      font-family: "PingFang SC-中黑体, PingFang SC";
      font-weight: normal;
      color: #adb0c7;
      line-height: 39px;
    }
    .head {
      display: -webkit-box;
    }
  }
  .headall {
    position: relative;
    .sousu1 {
      height: 56px;
      background: #2c3645;
      border-radius: 16px 16px 0 0;
      opacity: 1;

      display: flex;
      margin-top: 24px;
      margin-right: 32px;
      justify-content: space-between;
      align-content: center;
      span {
        height: 44px;
        margin-left: 16px;
        margin-top: 8px;
        font-size: 24px;
        font-family: SF Pro Text-Medium, SF Pro Text;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.55);
        line-height: 44px;
      }
      img {
        width: 48px;
        height: 48px;
        margin: 0 !important;
        margin-top: 8px !important;
      }
    }
    .sousu {
      height: 56px;
      background: #2c3645;
      border-radius: 16px 16px 16px 16px;
      opacity: 1;

      display: flex;
      margin-top: 24px;
      margin-right: 32px;
      justify-content: space-between;
      align-content: center;
      span {
        width: 130px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: 44px;
        margin-left: 16px;
        margin-top: 8px;
        font-size: 24px;
        font-family: SF Pro Text-Medium, SF Pro Text;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.55);
        line-height: 44px;
      }
      img {
        width: 48px;
        height: 48px;
        margin: 0 !important;
        margin-top: 8px !important;
      }
    }

    .headcontent {
      width: 294px;
      background: #2c3645;
      border-radius: 0px 0px 16px 16px;
      opacity: 1;
      position: absolute;
      right: 0px;
      top: 80px;
      ul {
        margin: 12px;
        li {
          height: 44px;
          line-height: 44px;
          font-size: 28px;
          font-family: SF Pro Text-Regular, SF Pro Text;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.9);
        }
        .active {
          color: #00a870;
        }
      }
    }
  }
  .head {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 690px;
    // height: 100px;
    opacity: 1;
    padding-left: 30px;
    text-align: left;
    font-size: 32px;
    font-family: SF Pro Text-Medium, SF Pro Text;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    // line-height: 100px;
    .address {
      width: 400px;
      color: rgba(255, 255, 255, 0.9);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    span {
      font-size: 26px;
      font-family: "PingFang SC-中黑体, PingFang SC";
      font-weight: normal;
      text-align: left;
      color: rgba(255, 255, 255, 0.9);
      line-height: 100px;
    }
    img {
      width: 45px;
      height: 45px;
      margin: 20px 30px 40px 0px;
    }
  }
  .content_img {
    img {
      width: 476px;
      height: 318px;
      margin: 100px 20px;
    }
  }
}
</style>
